import React from 'react';
import { quickEntries } from '../constants/mockData';
export function QuickEntryPanel() {
  return <div className="px-4 -mt-10 relative z-10" data-id="element-84">
      <div className="bg-white rounded-[36px] p-6 shadow-xl grid grid-cols-5 gap-y-6" data-id="element-85">
        {quickEntries.map(entry => <div key={entry.key} className="flex flex-col items-center gap-2 cursor-pointer active:opacity-70 transition-opacity" data-id="element-86">
            <div className="size-14 rounded-2xl flex items-center justify-center" data-id="element-87">
              <img src={entry.icon} alt={entry.title} className="size-12 object-contain" data-id="element-88" />
            </div>
            <span className="text-[24rpx] text-[#333333] font-medium" data-id="element-89">
              {entry.title}
            </span>
          </div>)}
      </div>
    </div>;
}